import api from './api';
import { API_PREFIX } from '../config';

export const authService = {
  async signup(userData) {
    const response = await api.post(`${API_PREFIX}/auth/signup`, userData);
    const { access_token, refresh_token, user } = response.data;
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    return { user, access_token };
  },

  async login(credentials) {
    const response = await api.post(`${API_PREFIX}/auth/login`, credentials);
    const { access_token, refresh_token, user } = response.data;
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    return { user, access_token };
  },

  async getMe() {
    const response = await api.get(`${API_PREFIX}/auth/me`);
    return response.data;
  },

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login';
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  },
};
